export const NOTIFICATIONS = {
  SHARE_PROGRAM_POPUP: 'SHARE_PROGRAM_POPUP',
};
